import { Navigate, useNavigate } from 'react-router-dom';
import { getRecommendationsListPath } from '../routes';
import {
	MaintenanceAdvicePage,
	buildMaintenanceStartPayload,
} from '@practium/features/recommendations';
import type { MaintenanceFormData } from '@practium/features/recommendations';
import { usePermissions } from '@practium/features/permissions';
import { useForBinding } from '@practium/features/forBinding';
import { useToast } from '@practium/ui';
import { usePostAdviceMaintenanceStart } from '@practium/features/api';

export const AddMaintenanceAdvicePageClient = () => {
	const navigate = useNavigate();
	const toast = useToast();
	const { isForBinding } = useForBinding();
	const { abilities } = usePermissions();
	const subject = isForBinding ? 'farmers-recommendations' : 'recommendations';
	const { mutateAsync: startMaintenanceAdvice } = usePostAdviceMaintenanceStart();

	const canCreate = abilities.can('create', subject);

	if (!canCreate) return <Navigate to="/recomendacoes" replace />;

	const handleStart = async (data: MaintenanceFormData) => {
		const advice = await startMaintenanceAdvice(buildMaintenanceStartPayload(data));
		toast.success('Recomendação iniciada com sucesso!');
		navigate(`/recomendacoes/manutencao/workspace?id=${advice._id}&tab=planning`, { replace: true });
	};

	return (
		<MaintenanceAdvicePage
			onBack={() => navigate(getRecommendationsListPath('maintenance'))}
			initialMode="add"
			onStart={handleStart}
		/>
	);
};
